import { z } from 'zod';
/**
 * RBAC permission keys (Domain 1 seeds the first set; extend via skill
 * `add-permission`). Format: `<cluster>:<action>`, aligned with AGENTS.md domains.
 */
export const PERMISSION_KEYS = {
    FINANCE_READ: 'finance:read',
    FINANCE_WRITE: 'finance:write',
    VISITS_READ: 'visits:read',
    VISITS_WRITE: 'visits:write',
    PATIENTS_READ: 'patients:read',
    PATIENTS_WRITE: 'patients:write',
    KITS_READ: 'kits:read',
    KITS_WRITE: 'kits:write',
    TRIALS_READ: 'trials:read',
    TRIALS_WRITE: 'trials:write',
    PERSONNEL_READ: 'personnel:read',
    PERSONNEL_WRITE: 'personnel:write',
    DOCUMENTS_READ: 'documents:read',
    TENANT_ADMIN: 'tenant:admin',
};
export const PermissionKeySchema = z.enum(Object.values(PERMISSION_KEYS));
//# sourceMappingURL=permissions.js.map